__webpack_require__.p = "https://yuanzao.oss-cn-beijing.aliyuncs.com/scratch-haiwai/";